module.exports = __webpack_public_path__ + "img/weddings_32_V.335ba698.webp";